import { httpCall, httpFetch } from '@/common/util';
import config from './endpoints';

export const getActivityListingData = (isListView, isSearch, payload) => {
  let endpoint;
  
  if (isListView) {
    endpoint = isSearch ? config.api.endpoints.listViewSearch : config.api.endpoints.listView;
  } else {
    endpoint = isSearch ? config.api.endpoints.cardViewSearch : config.api.endpoints.cardView;
  }
  
  return httpCall({
    method: 'GET',
    headers: { "Content-Type": "application/json" },
    params: payload,
    url: endpoint,
  });
};

export const activityGridBulkActionValidator = (payload) => {
  return httpFetch({
    url: config.api.endpoints.bulkActionHandler,
    method: 'POST',
    credentials: "include",
    data: payload,
  });
};

export const activityGridBulkActionConfirm = (actionType, payload) => {
  const endpointMap = {
    'AcceptActivity': config.api.endpoints.bulkAccept,
    'RejectActivity': config.api.endpoints.bulkReject,
    'AcceptAndReassignActivity': config.api.endpoints.bulkAcceptReassign,
  };
  
  return httpFetch({
    url: endpointMap[actionType] || config.api.endpoints.bulkAccept,
    method: 'POST',
    credentials: "include",
    data: payload,
  });
};

export const fetchAcceptReassignData = (payload) => {
  return httpFetch({
    url: config.api.endpoints.acceptReassignData,
    method: 'GET',
    credentials: "include",
    data: payload,
  });
};

export const validateBulkAcceptReassignActivity = (payload) => {
  return httpFetch({
    url: config.api.endpoints.bulkActionHandler,
    method: 'POST',
    credentials: "include",
    data: payload,
  });
};

export const changeAcceptReassignActivity = (payload) => {
  return httpFetch({
    url: config.api.endpoints.bulkAcceptReassign,
    method: 'POST',
    credentials: "include",
    data: payload,
  });
};